import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        count:0
    },
    mutations:{
        updateCount(state,val) {
            state.count = val
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/store.js